import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, ExternalLink } from 'lucide-react';
import { PROJECTS } from './Gallery';
import { Lightbox } from '../components/Lightbox';

const colsFor = (w) => (w >= 1024 ? 3 : w >= 640 ? 2 : 1);

const ProjectDetail = () => {
  const { id } = useParams();
  const project = PROJECTS.find(p => p.id === id);
  const [active, setActive] = useState(null);
  const [cols, setCols] = useState(() => colsFor(window.innerWidth));

  useEffect(() => {
    const onResize = () => setCols(colsFor(window.innerWidth));
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  if (!project) {
    return (
      <div className="px-6 md:px-12 py-12">
        <Link to="/" className="back-link flex items-center gap-2 mb-8">
          <ArrowLeft size={14} />
          Back to Projects
        </Link>
        <p className="text-sm text-gray-400">Project not found</p>
      </div>
    );
  }

  const images = project.images && project.images.length ? project.images : [project.image];

  return (
    <div className="px-6 md:px-12 py-8" data-testid="project-detail-page">
      <Link to="/" className="back-link flex items-center gap-2 mb-10" data-testid="back-link">
        <ArrowLeft size={14} />
        Back
      </Link>

      <h1 className="detail-header text-xl md:text-2xl mb-4" data-testid="project-title">
        {project.name}
      </h1>

      {project.behance && (
        <a
          href={project.behance}
          target="_blank"
          rel="noopener noreferrer"
          className="back-link flex items-center gap-2 mb-10"
          data-testid="behance-link"
        >
          View on Behance
          <ExternalLink size={12} />
        </a>
      )}

      <div className="masonry" data-testid="project-masonry">
        {Array.from({ length: cols }, (_, c) => (
          <div className="masonry-col" key={c}>
            {images.map((src, i) => i % cols === c && (
              <div
                key={src}
                className="masonry-item"
                style={{ animationDelay: `${Math.min(i, 8) * 0.07}s` }}
                onClick={() => setActive(i)}
                data-testid={`masonry-item-${i}`}
              >
                <img src={src} alt={`${project.name} ${i + 1}`} loading="lazy" draggable={false} />
                <div className="masonry-shield" />
              </div>
            ))}
          </div>
        ))}
      </div>

      {active !== null && (
        <Lightbox images={images} index={active} onClose={() => setActive(null)} onChange={setActive} />
      )}
    </div>
  );
};

export default ProjectDetail;
